<div class="filter-item" [formGroup]="filterGroup">
  <app-column-picker
    class="filter-item__column-picker"
    [preselectedColumnKey]="filterGroup.get('columnKey')?.value"
    [treeNodes]="treeNodes"
    [required]="true"
    [type]="type"
    (selectedColumnKey)="onColumnSelect($event)"></app-column-picker>
  <mat-form-field class="filter-item__filter-key">
    <mat-label>Filter Type</mat-label>
    <mat-select formControlName="filterKey">
      @for (filter of availableFilters; track filter.key) {
        <mat-option [value]="filter.key">{{ filter.name }}</mat-option>
      }
    </mat-select>
    @if (filterGroup.get('filterKey')?.hasError('required')) {
      <mat-error>Select filter type</mat-error>
    }
  </mat-form-field>
  <div class="filter-item__values">
    @if (!filterParams) {
      <div class="filter-item__placeholder">
        Please select {{ filterGroup.get('columnKey')?.value ? 'filter' : 'column' }}
      </div>
    } @else if (filterParams!.length === 1) {
      @switch (filterParams![0].dataType) {
        @case ('Text') {
          <app-text-filter [paramsGroup]="paramsGroup()"></app-text-filter>
        }
        @case ('DateTime') {
          <app-date-filter [paramsGroup]="paramsGroup()"></app-date-filter>
        }
        @case ('Number') {
          <app-number-filter [paramsGroup]="paramsGroup()"></app-number-filter>
        }
        @case ('TextArray') {
          <app-text-array-filter [paramsGroup]="paramsGroup()"></app-text-array-filter>
        }
        @case ('Any') {
          <app-any-filter [paramsGroup]="paramsGroup()" [columnDataType]="selectedColumn?.dataType"></app-any-filter>
        }
        @case ('AnyArray') {
          <app-any-array-filter
            [paramsGroup]="paramsGroup()"
            [allowedValues]="selectedColumn?.allowedValues"></app-any-array-filter>
        }
      }
    } @else if (filterParams!.length === 2) {
      <!-- add @switch when there will be more data types (like number range, etc)-->
      <app-date-range-filter [paramsGroup]="paramsGroup()"></app-date-range-filter>
    }
  </div>
  <span class="material-symbols-outlined filter-item__delete-icon" (click)="filterDeleted.emit()">delete</span>
</div>
